import styled from "styled-components";

export const Spinner = styled.div`
  width: 75px;
  margin: ${props =>
    props.inline ? "auto" : "calc(50vh - 90px) auto !important"};
`;
